"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _linkList = babelHelpers.interopRequireDefault(require("./linkList"));

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var ForumPostList = (_class = (_temp =
/*#__PURE__*/
function (_LinkListBlock) {
  babelHelpers.inherits(ForumPostList, _LinkListBlock);

  function ForumPostList() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ForumPostList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ForumPostList)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "showButton", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "groupLink", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "promoButtonText", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ForumPostList, [{
    key: "renderFooter",
    value: function renderFooter() {
      if (this.showButton) {
        var Node,
            attributes = {
          className: 'btn-secondary'
        };

        if (this.displayMode == 'none') {
          Node = 'span';
        } else {
          Node = 'a';
          attributes.href = this.groupLink;
        }

        return _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement(Node, attributes, this.promoButtonText));
      }

      return null;
    }
  }]);
  return ForumPostList;
}(_linkList.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "groupLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "promoButtonText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ForumPostList;